import { render, staticRenderFns } from "./MatchKinds.vue?vue&type=template&id=6cc5e480&"
import script from "./MatchKinds.vue?vue&type=script&lang=js&"
export * from "./MatchKinds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports